let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8dXNL")).then(() => parcelRequire('7EKT7'));